import React, { Component } from "react";
import { Container } from "react-bootstrap";
import "./Footer.css";

class Footer extends Component {
  render() {
    return (
      <div>
        <footer className="footer-el">
          <Container>
            <div className="row">
              <div className="col-sm-12 col-lg-4">
               
                <img
            className="footer_logo"
            src="./assets/images/logo.svg"
            alt="logo"
          />

              </div>
              <div className="col-sm-12 col-lg-4">
                <h4>Contact Information</h4>
                <p>
                  <i className="fas fa-map-marker-alt"></i> BBM UNIVERSAL (PTY)
                  306 Besswill, Corner Elsa & Weir street, Pretoria Gardens
                </p>
                <p>
                  <i className="fas fa-envelope"></i> info@bbmuniversal.co.za
                </p>
                <p>
                  <i className="fas fa-phone-alt"></i> +27 61 967 9859
                </p>
                <p>
                  <i className="fas fa-fax"></i> +27 86 683 8517
                </p>
              </div>
              <div className="col-sm-12 col-lg-4">
                <h4>Follow Us</h4>
                <div className="follow">
                  <i className="fab fa-facebook-square"></i>
                  <i className="fab fa-linkedin"></i>
                  <i className="fab fa-youtube-square"></i>
                </div>
              </div>
            </div>
          </Container>
        </footer>
      </div>
    );
  }
}

export default Footer;
